import { Vehicle } from "../../Interfaces/vehicle.type";
import getPaymentDataPush from "../getPaymentDataPush";
import getVehicleDataPush from "../getVehicleDataPush";

const payNowDataPush = (vehicle: Vehicle, value: string, invoiceNo: string) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);
  const paymentDataPush = getPaymentDataPush(value, invoiceNo);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "pay-now",
        action: "start",
        type: "",
      },
      ...vehicleDataPush,
      ...paymentDataPush,
    });
  }
};

export default payNowDataPush;
